/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_With_ColorInputs */

const en_resume_with_color = /** @type {(inputs: Resume_With_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With Color`)
};

const ar_resume_with_color = /** @type {(inputs: Resume_With_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بالألوان`)
};

const bn_resume_with_color = /** @type {(inputs: Resume_With_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রঙসহ`)
};

const de_resume_with_color = /** @type {(inputs: Resume_With_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit Farbe`)
};

const es_resume_with_color = /** @type {(inputs: Resume_With_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con color`)
};

const fr_resume_with_color = /** @type {(inputs: Resume_With_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avec couleur`)
};

const pt_resume_with_color = /** @type {(inputs: Resume_With_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com cores`)
};

const zh_resume_with_color = /** @type {(inputs: Resume_With_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`带颜色`)
};

const tr_resume_with_color = /** @type {(inputs: Resume_With_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renkli`)
};

const ru_resume_with_color = /** @type {(inputs: Resume_With_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`С цветом`)
};

const pl_resume_with_color = /** @type {(inputs: Resume_With_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Z kolorem`)
};

/**
* | output |
* | --- |
* | "With Color" |
*
* @param {Resume_With_ColorInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const resume_with_color = /** @type {((inputs?: Resume_With_ColorInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_With_ColorInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_resume_with_color(inputs)
	if (locale === "bn") return bn_resume_with_color(inputs)
	if (locale === "de") return de_resume_with_color(inputs)
	if (locale === "es") return es_resume_with_color(inputs)
	if (locale === "fr") return fr_resume_with_color(inputs)
	if (locale === "pt") return pt_resume_with_color(inputs)
	if (locale === "zh") return zh_resume_with_color(inputs)
	if (locale === "tr") return tr_resume_with_color(inputs)
	if (locale === "ru") return ru_resume_with_color(inputs)
	if (locale === "pl") return pl_resume_with_color(inputs)
	return en_resume_with_color(inputs)
});